import React from "react";
import styled from "styled-components";
import { Button } from "./Button";
import { usePostHog } from "posthog-js/react";

export const TesterButtonWrapper = styled.div`
  text-align: center;
  margin-block: 50px;
`;

export const TesterButton: React.FC<{ children: string }> = ({
  children = "Apply to be a tester",
}) => {
  const posthog = usePostHog();
  return (
    <Button
      as="a"
      href="https://research.typeform.com/to/XlGs2SHD"
      target="_blank"
      rel="noreferrer"
      onClick={(event) => {
        const url = new URL(event.currentTarget.href);
        url.searchParams.set("user_id", posthog.get_distinct_id());
        event.currentTarget.href = url.toString();
      }}
    >
      {children}
    </Button>
  );
};
